module.exports = __webpack_public_path__ + "d3516950c179c9468d4aaedd58d9f8d2.svg";